import { Modal, Flex, LoadingIndicator, Text } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";

interface SaveDashboardModalProps {
  isSaveModalOpen: boolean;
}

export const SaveDashboardModal: React.FC<SaveDashboardModalProps> = ({
  isSaveModalOpen,
}: SaveDashboardModalProps) => {
  return (
    <Modal show={isSaveModalOpen} size="medium" isCentered>
      <Modal.Body>
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={32}
          className={styles.saveModal}
        >
          <LoadingIndicator />
          <Text variant="h2">Saving dashboard</Text>
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

export default SaveDashboardModal;
